// React imports.
import React from "react";

//app imports
import {Assessment3VendorAssignedStatusEnum} from "../state";
import {Assessment3HHDataReceivedStatusEnum} from "../state";
import {Assessment3HHVendorsSelectedStatusEnum} from "../state";
import {Assessment3HHServedByVendorsProvidingDataStatusEnum} from "../state";
import {Assessment3RateOfReturnStatusEnum} from "../state";


const Assessment3Sup2TableRow = ({ state, fuel, rowClass }) => (
    <React.Fragment>
      <div className={"dwGridRow col1 "+ rowClass} >{fuel.description}</div>
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&
            <div className={"dwGridRow col2 blue-background "+ rowClass} >
                <input id="numHouseholds" value={fuel.numHouseholds }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsServedByVendorsProvidingData === true &&
            <div className={"dwGridRow col3 yellow-background "+ rowClass} >
                <input id="numHouseholdsServedByVendorsProvidingData" value={fuel.numHouseholdsServedByVendorsProvidingData }
                    onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuel)} 
                    className="form-control "  />
            </div>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentHouseholdsServedByVendorsProvidingData === true &&
            <React.Fragment>
                {(fuel.householdsServedByVendorsProvidingDataStatus ==Assessment3HHServedByVendorsProvidingDataStatusEnum.OverTargetNoIssues)
                    &&<div className={"dwGridRow col4 green-background "+ rowClass} >{fuel.percentHouseholdsServedByVendorsProvidingData}</div>
                }
                {(fuel.householdsServedByVendorsProvidingDataStatus ===Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget)
                    &&<div className={"dwGridRow col4 red-background "+ rowClass} >{fuel.percentHouseholdsServedByVendorsProvidingData}</div>
                }
            </React.Fragment>
        }
        {state.Assessment3Steps[state.CurrentAssessementStepIndex].showVendorsProvidingDataStatus === true &&
            <React.Fragment>
                {(fuel.numHouseholdsServedByVendorsProvidingData ===null
                    || fuel.numHouseholdsServedByVendorsProvidingData === 0)
                    &&
                    <div className={"dwGridRow col5 red-background "+ rowClass} >
                        <span>
                            <strong>Potential Issue – </strong>
                            You did not report a number 
                            of  {fuel.description}  households served by vendors
                            from whom data was received.
                        </span>
                    </div>
                }
                {(fuel.householdsServedByVendorsProvidingDataStatus === Assessment3HHServedByVendorsProvidingDataStatusEnum.OverTargetNoIssues
                      &&fuel.numHouseholdsServedByVendorsProvidingData !== null
                      && fuel.numHouseholdsServedByVendorsProvidingData > 0)
                    &&
                    <div className={"dwGridRow col5 green-background "+ rowClass} >
                        <span>
                            <strong>No Issue Flagged –</strong>
                            The vendors that complied with your data request represent
                            at least  {fuel.targetPercentHouseholdsCoveredString}  of
                            your  {fuel.description}  households.
                        </span>
                    </div>
                }
                {(fuel.numHouseholdsServedByVendorsProvidingData > 0
                    && fuel.numHouseholdsServedByVendorsProvidingData !== null
                    && fuel.householdsServedByVendorsProvidingDataStatus ===Assessment3HHServedByVendorsProvidingDataStatusEnum.NotMeetTarget)
                    &&<div className={"dwGridRow col5 red-background "+ rowClass} >
                        <span>
                            <strong>Potential Issue –</strong>
                            The vendors that complied with your data request DO NOT represent at
                            least  {fuel.targetPercentHouseholdsCoveredString}  of
                            your  {fuel.description}  households. 
                        </span>
                      </div>
                }
            </React.Fragment>



        }
    </React.Fragment>
);

export default Assessment3Sup2TableRow;
